var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plate-intensity-chart",staticStyle:{"width":"100%","height":"80px"}},[_c('v-chart',{staticStyle:{"width":"100%","height":"100%"},attrs:{"options":_vm.chartOptions,"autoresize":"","theme":"roma"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }